import {getTailwindBreakpoint} from "@/lib/utils/functions/getTailwindBreakpoint";
import {TailwindBreakpointsEnum} from "@/lib/enums/TailwindBreakpointsEnum";

export const calcAmountOfCards = (map: Record<TailwindBreakpointsEnum, number>) => {
    const isBrowser = typeof window !== 'undefined';
    const breakpoint = isBrowser ? getTailwindBreakpoint(window.innerWidth) : undefined;
    return breakpoint ? map[breakpoint] : 0;
}
